import { FruitfulCustomIcon } from '../icons/FruitfulCustomIcon';
import { redactPrivate } from '../security/Private';
import { TextRow } from './TextRow';

export interface AccountRowProps {
    accountName: string;
    accountIcon?: string | null;
    accountColor?: string | null;
    isJointAccount: boolean;
    isJointMembership: boolean;
    balance: string;
    onPress?: () => void;
}

export const AccountRow = ({
    accountName,
    accountIcon,
    accountColor,
    isJointAccount,
    isJointMembership,
    balance,
    onPress,
}: AccountRowProps) => {
    // TODO - Investment accounts, etc will use different subtitle logic.
    const subtitle = isJointMembership
        ? isJointAccount
            ? 'Joint account'
            : 'Individual account'
        : undefined;

    return (
        <TextRow
            title={accountName}
            subtitle={subtitle}
            secondaryText={balance}
            onPress={onPress}
            titleProps={{ ...redactPrivate() }}
            secondaryTextProps={{ ...redactPrivate() }}
            leftContentOverride={
                <FruitfulCustomIcon icon={accountIcon} color={accountColor} />
            }
        />
    );
};
